import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export const PartnershipsCarousel = {
	init() {
		document.querySelectorAll( '[data-partnerships-logos]' ).forEach( ( container ) => {
			if ( container.dataset.partnershipsInit === '1' ) return;
			container.dataset.partnershipsInit = '1';

			const track = container.querySelector( '.partnerships-track' );
			if ( ! track ) return;

			const logos = Array.from( track.querySelectorAll( '.block-partnerships__logo' ) );
			if ( ! logos.length ) return;

			// Swiper v12 loop requires slides.length > slidesPerView.
			// Clone originals once (2× total) to always satisfy that condition.
			logos.forEach( ( logo ) => {
				const clone = logo.cloneNode( true );
				clone.setAttribute( 'aria-hidden', 'true' );
				clone.dataset.partnershipsClone = '1';
				track.appendChild( clone );
			} );

			track.classList.add( 'swiper-wrapper' );
			track.classList.remove( 'partnerships-track' );
			container.classList.add( 'swiper' );

			Array.from( track.querySelectorAll( '.block-partnerships__logo' ) ).forEach(
				( logo ) => logo.classList.add( 'swiper-slide' )
			);

			new Swiper( container, {
				modules: [ Autoplay ],
				slidesPerView: 1.2,
				spaceBetween: 16,
				loop: true,
				speed: 800,
				autoplay: { delay: 2000, disableOnInteraction: false },
				breakpoints: {
					481: { slidesPerView: 2,   spaceBetween: 24 },
					769: { slidesPerView: 3,   spaceBetween: 32 },
					1025: { slidesPerView: 6,  spaceBetween: 32 },
				},
			} );
		} );
	},
};
